import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import WaLink, { btnAccent } from './WaLink';

const links = [
  ['About', '#about'],
  ['Services', '#services'],
  ['Bridal', '#bridal'],
  ['Gallery', '#gallery'],
  ['Packages', '#packages'],
  ['Contact', '#contact'],
];

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#351427] shadow-lg">
      <div className="mx-auto flex h-[76px] max-w-[1280px] items-center justify-between px-4 sm:px-6">
        <a href="#home" className="flex items-center gap-3" aria-label="Blush & Bloom home">
          <span className="grid h-11 w-11 place-items-center rounded-lg border border-[#d5b778] text-[#d5b778]">
            <SafeIcon icon={FiIcons.FiFeather} className="text-xl" />
          </span>
          <span className="font-display text-xl leading-none text-white">
            Blush &amp;Bloom
            <small className="block pt-1 font-sans text-[9px] tracking-[0.3em] text-[#d5b778]">
              BEAUTY STUDIO
            </small>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Main navigation">
          {links.map(([label, href]) => (
            <a
              key={href}
              href={href}
              className="text-sm font-medium text-white/85 transition hover:text-[#d5b778]"
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <WaLink className={`${btnAccent} hidden !px-5 !py-2.5 lg:inline-flex`}>
            Contact Us
          </WaLink>
          <button
            type="button"
            className="grid h-10 w-10 place-items-center rounded-lg border border-white/30 text-white lg:hidden"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            <SafeIcon icon={open ? FiIcons.FiX : FiIcons.FiMenu} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-white/10 bg-[#351427] px-4 py-3 lg:hidden" aria-label="Mobile navigation">
          {links.map(([label, href]) => (
            <a
              key={href}
              href={href}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-3 py-3 text-white/90 hover:bg-white/10"
            >
              {label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}

export default Header;
